/**
 * Convierte una imagen JPG/PNG a WebP en el navegador antes de subirla a Firebase Storage.
 * Si la imagen ya es WebP o un formato no convertible (GIF, SVG, etc.), devuelve el archivo original.
 * Tambien redimensiona si excede maxWidth (manteniendo proporcion).
 */
export async function optimizeImage(file, options) {
  if (!file) return null
  options = options || {}
  const maxWidth = options.maxWidth || 1600
  const quality = typeof options.quality === 'number' ? options.quality : 0.85

  const fileType = (file.type || '').toLowerCase()
  const isConvertible = fileType === 'image/jpeg' || fileType === 'image/jpg' || fileType === 'image/png'

  const originalName = file.name || 'image'
  const dotIdx = originalName.lastIndexOf('.')
  const baseName = dotIdx >= 0 ? originalName.slice(0, dotIdx) : originalName
  const originalExt = dotIdx >= 0 ? originalName.slice(dotIdx) : ''

  if (!isConvertible) {
    return { blob: file, extension: originalExt, name: originalName }
  }

  try {
    const img = await loadImage(file)
    const scale = Math.min(1, maxWidth / img.width)
    const w = Math.round(img.width * scale)
    const h = Math.round(img.height * scale)

    const canvas = document.createElement('canvas')
    canvas.width = w
    canvas.height = h
    const ctx = canvas.getContext('2d')
    ctx.drawImage(img, 0, 0, w, h)

    const blob = await new Promise(function (resolve) {
      canvas.toBlob(resolve, 'image/webp', quality)
    })

    if (!blob) {
      return { blob: file, extension: originalExt, name: originalName }
    }

    return { blob: blob, extension: '.webp', name: baseName + '.webp' }
  } catch (err) {
    if (typeof console !== 'undefined' && console.warn) {
      console.warn('[optimizeImage] fallback al original:', err)
    }
    return { blob: file, extension: originalExt, name: originalName }
  }
}

function loadImage(file) {
  return new Promise(function (resolve, reject) {
    const url = URL.createObjectURL(file)
    const img = new Image()
    img.onload = function () {
      URL.revokeObjectURL(url)
      resolve(img)
    }
    img.onerror = function (e) {
      URL.revokeObjectURL(url)
      reject(e)
    }
    img.src = url
  })
}
